import React from 'react'
import * as i18next from 'i18next'

import Divider from 'app/app/(client)/components/atoms/Divider/Divider'
import PillBox from 'app/app/(client)/components/molecules/PillBox/PillBox'
import { OpportunityFilterOption } from 'app/types/ui/opportunity'

interface SelectedBadgesProps {
  id: string
  filterKey: OpportunityFilterOption[]
  setFilterKey: (val: OpportunityFilterOption[]) => void
}

const SelectedBadges: React.FC<SelectedBadgesProps> = ({ id, filterKey, setFilterKey }) => {
  const handleRemove = (val: OpportunityFilterOption) => {
    if (Array.isArray(filterKey)) {
      setFilterKey(filterKey.filter(v => v.key !== val.key))
    } else if (
      typeof filterKey === 'object' &&
      filterKey !== null &&
      (filterKey as OpportunityFilterOption).key === val.key
    ) {
      setFilterKey([])
    }
  }

  const getByLabel = (option: OpportunityFilterOption): string => {
    if (!option || !option.value) {
      return String(option)
    }
    if (typeof option.value === 'function') {
      return option.value(i18next.default)
    }
    return option.value
  }

  if (!Array.isArray(filterKey) || filterKey.length === 0) {
    return null
  }

  return (
    <div id={id} className="w-full md:px-4 ">
      <div className="flex flex-wrap gap-2 mt-3 md:mt-0 mb-3 md:mb-6">
        {filterKey.map(selectedFilterKey => (
          <PillBox
            key={`selected-pillbox-${selectedFilterKey.key}`}
            id={`selected-pillbox-${selectedFilterKey.key}`}
            label={getByLabel(selectedFilterKey)}
            onRemove={() => handleRemove(selectedFilterKey)}
            variant="small"
          />
        ))}
      </div>
      <Divider orientation="horizontal" className="divider" />
    </div>
  )
}

export default SelectedBadges
